<template>
	<span v-if="hasAppointments" class="action-container">
		<a
			href="#"
			class="action lime"
			@click.prevent="showAppointments"
		>
			<Icon icon="calendar"/>
			<span class="count-bubble">{{ appointmentsCount }}</span>
		</a>
	</span>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import {mapActions} from "vuex";
import {LIST_TYPE__CUSTOMER} from "@/store/communication/appointment";

export default {

	components: {
		Icon,
	},

	props: {
		jobProfileListItem: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			showInfoPopUp: false,
		};
	},

	computed: {
		hasAppointments ()
		{
			return this.appointmentsCount > 0;
		},
		appointmentsCount ()
		{
			return this.jobProfileListItem.appointmentsCount;
		},
	},

	methods: {
		...mapActions('communication/appointment', {
			openAppointmentFan: 'show'
		}),
		showAppointments ()
		{
			this.openAppointmentFan({
				listType: LIST_TYPE__CUSTOMER,
				jobProfileId: this.jobProfileListItem.jobProfile.id,
				onClose: () =>
				{
					this.$emit('closeAppointments');
				}
			});
		}
	}
}
</script>
